/**
 * Graham Machine - Custom Global Logic
 * Handles page animations and performance optimizations
 */

document.addEventListener('DOMContentLoaded', () => {
  // Trigger page fade-in
  const mainContent = document.querySelector('.main-content');
  if (mainContent) {
    // Small timeout ensures the browser has a frame to catch the transition
    requestAnimationFrame(() => {
      mainContent.classList.add('is-loaded');
    });
  }
});
